import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const defaultDrawingState = {
    promotionId: 0,
    view: 'approved',
    drawings: [],
};

const getDrawingsReducer = (state, action) => {
    return {
        promotionId: action.payload.promotionId,
        drawings: action.payload.drawings,
        view: action.payload.view,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultDrawingState,
    };
};

export const drawingSlice = createSlice({
    name: 'drawing',
    initialState: defaultDrawingState,
    reducers: {
        getDrawings: getDrawingsReducer,
        reset: resetReducer,
    },
});

const getDrawings = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getDrawings' }));
    const result = await apiClient.getDrawings(payload);
    dispatch(drawingSlice.actions.getDrawings(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getDrawings' }));
};

// actions that get exported to the views
export const drawingActions = (dispatch) => {
    return {
        getDrawings: (payload) => getDrawings(dispatch, payload),
        reset: (payload) => dispatch(drawingSlice.actions.reset(payload)),
    };
};
